import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Component: MTO Countdown
 * ------------------------------------------------------------------------------
 * Script used to append a countdown timer to each product card.
 *
 * @namespace mtoCountdown
 */

import countDown from '~/components/count-down';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-count-down="container"]'
};
/**
 * Set promotional banner script.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  let nodeSelectors;

  function setNodeSelectors() {
    nodeSelectors = {
      container: document.querySelectorAll(selectors.container)
    };
  }
  /**
   * Countdown entry function.
   */


  function setCountdown() {
    setNodeSelectors();

    if (nodeSelectors.container.length === 0) {
      return;
    }

    [...nodeSelectors.container].forEach(element => {
      countDown().init(element);
    });
  }
  /**
   * Initialise component.
   */


  function init() {
    exposeCountdown();
    setCountdown();
  }
  /**
   * Expose countdown functionality to boost.
   */


  function exposeCountdown() {
    theme.collectionCountdown = () => {
      setCountdown();
    };
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});